import requestAdmin from "../utils/requestAdmin";
import requestAuth from "../utils/requestAuth";
import axios from "axios";

export function login({ login, password }) {
  return requestAuth("/login", {
    method: "POST",
    body: { login, password },
  });
}

export function ccadminLogin({ username, password }) {
  const params = new URLSearchParams();
  params.append("login", username);
  params.append("password", password);
  return requestAdmin("/login", {
    method: "POST",
    body: params,
  });
}

export function logout() {
  localStorage.clear();
  return requestAuth("/logout");
}

const API_URL = "http://10.202.65.2:8080/api/kulsary";

const instance = (authorization = true, isBasic = false, url = null) => {
  const axiosInstance = axios.create({
    baseURL: url || API_URL,
  });

  if (authorization) {
    axiosInstance.interceptors.request.use(
      (config) => {
        config.headers.Authorization = `Bearer ${window.localStorage.getItem(
          "token"
        )}`;
        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  return axiosInstance;
};

export default instance;

const API_BASE = "/api";

async function postJson(path, body) {
  const res = await fetch(API_BASE + path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    let msg = "Ошибка запроса";
    try {
      msg = (await res.json()).message || msg;
    } catch (_) {}
    throw new Error(msg);
  }
  try {
    return await res.json();
  } catch (_) {
    return {};
  }
}

export const passwordRecoveryRequest = (email) =>
  postJson("/auth/v1/password-recovery/request", { email });

export const passwordRecoveryVerify = ({ token, code }) =>
  postJson("/auth/v1/password-recovery/verify", { token, code });

export const passwordRecoveryReset = ({ token, newPassword }) =>
  postJson("/auth/v1/password-recovery/reset", { token, newPassword });
